import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '../../atoms';
import { RoundedCheckboxLabel } from './styles.js';

export const RoundedCheckbox = ({
  value,
  onChange,
  label,
  checked,
  unavailable,
}) => {
  return (
    <RoundedCheckboxLabel
      htmlFor={`${value}-checkbox-input`}
      checked={checked}
      unavailable={unavailable}
    >
      <VisuallyHidden>
        <input
          type="checkbox"
          id={`${value}-checkbox-input`}
          name={value}
          checked={checked && !unavailable}
          disabled={unavailable}
          onChange={onChange}
        />
      </VisuallyHidden>
      {label}
    </RoundedCheckboxLabel>
  );
};

RoundedCheckbox.displayName = 'RoundedCheckbox';

RoundedCheckbox.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  unavailable: PropTypes.bool,
};
